import { FunctionComponent } from 'react';

// modules
import { MainProfileStyle } from './Styles';

const { Container, ProfileImage, ProfileTitle } = MainProfileStyle;

const MainProfile: FunctionComponent<{}> = () => {
  return (
    <Container>
      <ProfileImage
        data-aos="fade-up"
        data-aos-duration="500" />
      <ProfileTitle
        data-aos="fade-right"
        data-aos-delay="500"
        data-aos-duration="500">
        <h2>게으른 개발자 입니다!🙇‍♂️</h2>
        {/* <h3>Front-end developer</h3>
        <p>🐧 PureJavascript (ES5+), Typescript</p>
        <p>⚛️ Framework (React, Vue)</p>
        <p>📱 Hybrid App (ReactNative, Ionic)</p>
        <p>🖥 Node.js</p> */}
      </ProfileTitle>
    </Container>
  );
};

export default MainProfile;